let playerHitArea: number;
let playerMinSpeed: number;
let playerMaxSpeed: number;
let maxLineLength: number;
let playerMaxVelocity:number;
let availableAmountOfPowerups:number;
let minSpeedBeforeAllowingNewSpin:number;
export const GameConfig = {
  playerHitArea: 30,
  playerMinSpeed: 20,
  playerMaxSpeed: 7000,
  maxLineLength: 200,
  playerMaxVelocity: 2000,
  availableAmountOfPowerups:3,
  minSpeedBeforeAllowingNewSpin:200,
} as const;
